import { SET_IS_SAVING } from 'redux/types'

const setIsSaving = (payload) => {
  return { type: SET_IS_SAVING, payload }
}

export {
  setIsSaving
}